import App from 'common/backbone-app';
import Wahanda from 'common/wahanda';
import * as localesConfig from 'config/domains-locales';

type ReferSalonUrlParams = {
  venueId: number | string;
  venueName: string;
  emailAddress: string;
  accountId: number | string;
};

export const referSalonUrl = ({
  venueId,
  venueName,
  emailAddress,
  accountId,
}: ReferSalonUrlParams) => {
  const domain = localesConfig.DOMAIN_TO_LOCALE_MAP_INVERTED[App.getClientLocale()];
  const url = new URL(Wahanda.lang.home.contacts.referSalonUrl, `https://www.${domain}`);

  url.searchParams.append('venue_id', String(venueId));
  url.searchParams.append('venue_name', venueName);
  url.searchParams.append('referrer_email', emailAddress);
  url.searchParams.append('referrer_id', String(accountId));
  url.searchParams.append('referrer_type', 'connect');

  return url.href;
};

// The `#venue/<id>` hash is dropped, as in the photoshoot flow — the flow's
// own step routing owns the rest of the URL.
export const phoneSupportUrl = () => Wahanda.Url.getFullUrl('phone-support').split('#')[0];
